import AppLayout from '../Layout/AppLayout';
import ContenuGestionTickets from '../Components/ContenuGestionTickets';

const GestionTickets = () => {
    return (
        <AppLayout>
            <ContenuGestionTickets />
        </AppLayout>
    );
};

export default GestionTickets;
